/* GROESSE BEIM HOCHSETZEN DER MENGE
 *
 * Ausgangslage (gemessen am 25.08.2026): Erhoeht ein Kunde im Warenkorb die
 * Menge einer Zeile "Knickschutz, 2 Paar, S + L" von 1 auf 2, vervielfacht
 * Shopify die Zeile samt Groessen - er bekommt 2x S und 2x L. Das ist nicht
 * falsch, aber es ist auch nicht gefragt worden. Wer ein drittes Paar in M
 * will, muss den Umweg ueber die Produktseite gehen.
 *
 * Deshalb: Beim HOCHSETZEN wird nach den Groessen der zusaetzlichen Paare
 * gefragt, und das Ergebnis geht als EIGENE Warenkorbzeile hinein. Damit
 * bleibt die Grundregel des Ladens erhalten - eine Zeile traegt genau einen
 * Satz Groessen. Genau so legt Shopify die Zeilen auch von sich aus an, wenn
 * dasselbe Produkt mit anderen Groessen dazukommt.
 *
 * Runtersetzen und Entfernen laufen unveraendert durch Dawn.
 *
 * WIE DER EINGRIFF FUNKTIONIERT: Dawns <cart-items> hoert auf 'change' an sich
 * selbst, also in der Bubble-Phase. Ein Zuhoerer am Dokument in der
 * CAPTURE-Phase kommt davor dran und kann mit stopPropagation() verhindern,
 * dass Dawn die Aenderung ueberhaupt sieht. Die Entscheidung muss dabei SOFORT
 * fallen - deshalb wird das Produkt am Link der Zeile erkannt und nicht erst
 * aus /cart.js geholt.
 */
(function () {
  "use strict";

  var doc = document;

  /* Die Raster kommen aus snippets/mv-groesse.liquid - der einzigen Quelle.
     Ohne diese Daten greift hier gar nichts, dann bleibt es beim alten
     Verhalten von Dawn. Das ist der sichere Ausgang, nicht der stille Fehler. */
  var RASTER = (function () {
    var el = doc.getElementById("mvGroessenDaten");
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  })();

  function handleDerZeile(reihe) {
    var link = reihe && reihe.querySelector("a[href*='/products/']");
    if (!link) return null;
    var m = link.getAttribute("href").match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  /* Wie viele Paare steckt EIN Stueck dieser Zeile? Die Variante heisst
     "1 Paar" / "2 Paar" / "3 Paar", daraus kommt die Zahl. Faellt das aus,
     wird ersatzweise gezaehlt, wie viele Groessen die Zeile schon traegt. */
  function paareJeStueck(posten) {
    var n = parseInt(posten.variant_title, 10);
    if (!isNaN(n) && n > 0 && n <= 10) return n;
    var z = 0, p = posten.properties || {};
    Object.keys(p).forEach(function (k) { if (/^Größe Paar \d+$/.test(k)) z++; });
    return z > 0 ? z : 1;
  }

  /* ---------------------------------------------------------------- Dialog */

  var dlg = null, felder = [], zustand = null;

  function dialogBauen() {
    if (dlg) return dlg;
    dlg = doc.createElement("dialog");
    dlg.className = "mvkg";
    dlg.setAttribute("aria-labelledby", "mvkgTitel");
    dlg.innerHTML =
      '<div class="mvkg__k">' +
        '<h2 class="mvkg__t" id="mvkgTitel"></h2>' +
        '<p class="mvkg__u"></p>' +
        '<div class="mvkg__felder"></div>' +
        '<p class="mvkg__fehl" role="alert" hidden>Bitte noch alle Gr&ouml;&szlig;en w&auml;hlen.</p>' +
        '<div class="mvkg__knoepfe">' +
          '<button type="button" class="mvkg__ab">Abbrechen</button>' +
          '<button type="button" class="mvkg__ok">Dazulegen</button>' +
        '</div>' +
      '</div>';
    doc.body.appendChild(dlg);

    dlg.querySelector(".mvkg__ab").addEventListener("click", schliessen);
    dlg.querySelector(".mvkg__ok").addEventListener("click", uebernehmen);
    /* Esc und Klick auf den Hintergrund brechen ab - beides darf nichts in den
       Korb legen, sonst laege dort ein Paar ohne bewusste Wahl. */
    dlg.addEventListener("cancel", function (e) { e.preventDefault(); schliessen(); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg) schliessen(); });
    return dlg;
  }

  function beschriftung(u, p, zuwachs, paare) {
    if (zuwachs === 1) return paare === 1 ? "Größe" : "Paar " + p;
    if (paare === 1) return "Paar " + (u + 1);
    return (u + 1) + ". Set, Paar " + p;
  }

  function oeffnen(posten, zuwachs, werte, zeileNr) {
    var paare = paareJeStueck(posten);
    var gesamt = zuwachs * paare;
    dialogBauen();

    dlg.querySelector(".mvkg__t").textContent = gesamt === 1
      ? "Welche Größe für das zusätzliche Paar?"
      : "Welche Größen für die zusätzlichen Paare?";
    dlg.querySelector(".mvkg__u").textContent =
      posten.product_title.replace(/^Miravello /, "") + " — du legst " +
      (gesamt === 1 ? "ein weiteres Paar" : gesamt + " weitere Paare") + " dazu.";

    var box = dlg.querySelector(".mvkg__felder");
    box.innerHTML = "";
    felder = [];
    for (var u = 0; u < zuwachs; u++) {
      for (var p = 1; p <= paare; p++) {
        var reihe = doc.createElement("label");
        reihe.className = "mvg";
        var lab = doc.createElement("span");
        lab.className = "mvg__l mono";
        lab.textContent = beschriftung(u, p, zuwachs, paare);
        var sel = doc.createElement("select");
        sel.className = "mvg__f";
        sel.appendChild(new Option("Größe wählen", ""));
        werte.forEach(function (w) { sel.appendChild(new Option(w, w)); });
        sel.addEventListener("change", function () {
          this.classList.toggle("is-fehlt", !this.value);
          if (felder.every(function (f) { return f.el.value; })) meldung(false);
        });
        reihe.appendChild(lab);
        reihe.appendChild(sel);
        box.appendChild(reihe);
        felder.push({ el: sel, u: u, p: p });
      }
    }

    meldung(false);
    zustand = { posten: posten, zuwachs: zuwachs, paare: paare, zeile: zeileNr };
    if (typeof dlg.showModal === "function") dlg.showModal(); else dlg.setAttribute("open", "");
    if (felder[0]) felder[0].el.focus();
  }

  function meldung(zeigen) {
    var m = dlg.querySelector(".mvkg__fehl");
    if (m) m.hidden = !zeigen;
  }

  function schliessen() {
    if (!dlg) return;
    if (typeof dlg.close === "function" && dlg.open) dlg.close(); else dlg.removeAttribute("open");
    zustand = null;
  }

  function uebernehmen() {
    if (!zustand) return;
    var offen = felder.filter(function (f) { return !f.el.value; });
    if (offen.length) {
      offen.forEach(function (f) { f.el.classList.add("is-fehlt"); });
      meldung(true);
      offen[0].el.focus();
      return;
    }

    /* Ein Eintrag je zusaetzlichem Stueck, jeder mit seinen eigenen Groessen.
       Sind zwei davon gleich, fasst Shopify sie von selbst zu einer Zeile mit
       Menge 2 zusammen - dafuer ist hier nichts zu tun. */
    var posten = [];
    for (var u = 0; u < zustand.zuwachs; u++) {
      var eig = {};
      felder.filter(function (f) { return f.u === u; }).forEach(function (f) {
        eig["Größe Paar " + f.p] = f.el.value;
      });
      posten.push({ id: zustand.posten.variant_id, quantity: 1, properties: eig });
    }

    var ok = dlg.querySelector(".mvkg__ok");
    ok.disabled = true;
    ok.textContent = "…";

    var koerper = { items: posten };
    var hilfe = window.mvDawn;
    if (hilfe && typeof hilfe.abschnitte === "function") {
      koerper.sections = hilfe.abschnitte();
      koerper.sections_url = window.location.pathname;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(koerper)
    })
      .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
      .then(function (a) {
        ok.disabled = false;
        ok.textContent = "Dazulegen";
        schliessen();
        if (hilfe && typeof hilfe.einspielen === "function") {
          hilfe.einspielen(a);
          if (typeof window.mvVersandAktualisieren === "function") {
            fetch("/cart.js", { headers: { Accept: "application/json" } })
              .then(function (r) { return r.json(); })
              .then(function (k) { window.mvVersandAktualisieren(k.items_subtotal_price); });
          }
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        ok.disabled = false;
        ok.textContent = "Dazulegen";
        meldung(true);
        dlg.querySelector(".mvkg__fehl").textContent =
          "Das hat gerade nicht geklappt. Bitte noch einmal versuchen.";
      });
  }

  /* ------------------------------------------------------------ Abfangen */

  doc.addEventListener("change", function (e) {
    var feld = e.target;
    if (!feld || feld.name !== "updates[]") return;

    var alt = parseInt(feld.defaultValue, 10);
    var neu = parseInt(feld.value, 10);
    /* Runter oder gleich: Dawn macht das wie immer. Nur das Hochsetzen ist die
       Stelle, an der Groessen fehlen wuerden. */
    if (isNaN(alt) || isNaN(neu) || neu <= alt) return;

    var reihe = feld.closest(".cart-item");
    var handle = handleDerZeile(reihe);
    var werte = handle ? RASTER[handle] : null;
    if (!werte || !werte.length) return;

    e.stopPropagation();
    e.preventDefault();
    var zeileNr = feld.dataset.index;
    feld.value = feld.defaultValue;   // Anzeige zurueck, bis wirklich etwas passiert

    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (k) {
        var posten = k.items[parseInt(zeileNr, 10) - 1];
        if (!posten) return;
        oeffnen(posten, neu - alt, werte, zeileNr);
      })
      .catch(function () { /* still: dann bleibt die Menge einfach unveraendert */ });
  }, true);
})();
